import React from 'react'
import map from 'lodash/map'
import LabelRow from './LabelRow'

import {
  ILabel,
} from '@SiteModules/Label/types'

import {
  IOpenDeleteLabelPopupPayload,
  IOpenRenameLabelPopupPayload,
} from '@SiteModules/Popup/types'

import './LabelsTableList.scss'

interface LabelsTableListProps {
  readonly labels: ILabel[]
  openDeleteLabelPopup(payload: IOpenDeleteLabelPopupPayload): void
  openRenameLabelPopup(payload: IOpenRenameLabelPopupPayload): void
}

const LabelsTableList: React.FC<LabelsTableListProps> = props => {
  const {
    labels,
  } = props

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="LabelsTableList__name">
          Name
        </th>
        <th className="LabelsTableList__use-in-projects">
          Use in projects
        </th>
        <th className="LabelsTableList__created">
          Created
        </th>
        <th className="LabelsTableList__edited">
          Edited
        </th>
        <th className="LabelsTableList__more"/>
      </tr>
    )
  }

  const tableRows = map(labels, (label, index) => {
    return (
      <LabelRow
        key={index}
        index={index}
        label={label}
        openDeleteLabelPopup={props.openDeleteLabelPopup}
        openRenameLabelPopup={props.openRenameLabelPopup}
      />
    )
  })

  return (
    <div className="LabelsTableList">
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody className="LabelsTableList__body">
          {tableRows}
        </tbody>
      </table>
    </div>
  )
}

export default LabelsTableList
